import React, { useState } from 'react';
import { resetPassword, type ResetPasswordOutput } from 'aws-amplify/auth';
import {
    confirmResetPassword,
    type ConfirmResetPasswordInput
} from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';


interface ForgotPasswordProps { }

const ForgotPassword: React.FC<ForgotPasswordProps> = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [codeSent, setCodeSent] = useState(false);
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');

    async function handleConfirmResetPassword({
        username,
        confirmationCode,
        newPassword
    }: ConfirmResetPasswordInput) {
        try {
            await confirmResetPassword({ username, confirmationCode, newPassword });
        } catch (error) {
            console.log(error);
        }
    }

    const handleForgotPassword = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const output = await resetPassword({ username: email });
            handleResetPasswordNextSteps(output);
        } catch (error) {
            console.error('Error during forgot password:', error);
        }
    };

    const handleResetPasswordNextSteps = (output: ResetPasswordOutput) => {
        const { nextStep } = output;
        switch (nextStep.resetPasswordStep) {
            case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
                const codeDeliveryDetails = nextStep.codeDeliveryDetails;
                console.log(
                    `Confirmation code was sent to ${codeDeliveryDetails.deliveryMedium}`
                );
                setCodeSent(true);
                break;
            case 'DONE':
                console.log('Successfully reset password.');
                // Navigate to login page
                break;
        }
    };

    const handleResetPassword = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await handleConfirmResetPassword({ username: email, confirmationCode: code, newPassword: newPassword });
            navigate('/login', { state: { resetSuccess: true } });
            // Password reset successful, navigate to login page
        } catch (error) {
            console.error('Error during password reset:', error);
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 flex justify-center items-center">
            <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
                <div className="flex justify-center">
                    <img
                        src="/images/jack-logo.jpg"
                        alt="Jack Logo"
                        style={{ maxWidth: "80%", maxHeight: "30%" }}
                        className='pb-8'
                    />
                </div>
                <h2 className="text-2xl font-bold mb-6">Forgot Password</h2>
                {!codeSent ? (
                    <form onSubmit={handleForgotPassword}>
                        <p className="mb-4">Enter your Email below and we will send a code to reset your password.</p>
                        <div className="mb-4">
                            <label htmlFor="email" className="block mb-2 font-bold text-gray-700">
                                Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-[#43a4db] text-white font-bold py-2 px-4 rounded-md hover:bg-[#2a6e95] transition duration-300"
                        >
                            Send Verification Code
                        </button>
                    </form>
                ) : (
                    <form onSubmit={handleResetPassword}>
                        <div className="mb-4">
                            <label htmlFor="code" className="block mb-2 font-bold text-gray-700">
                                Verification Code
                            </label>
                            <input
                                type="text"
                                id="code"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                placeholder="Verification Code"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                        <div className="mb-6">
                            <label htmlFor="newPassword" className="block mb-2 font-bold text-gray-700">
                                New Password
                            </label>
                            <input
                                type="password"
                                id="newPassword"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder="New Password"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-[#43a4db] text-white font-bold py-2 px-4 rounded-md hover:bg-[#2a6e95] transition duration-300"
                        >
                            Reset Password
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;